import {
  Introduction,
  BoxIntroduction,
  Heading,
  WelcomeContent,
  HeroImage
} from './styled.js'
import babyImage from '../DSC_9628-przyciete.jpg'

const Intro = () => (
  <Introduction>
    <HeroImage src={babyImage} alt='' />
    <BoxIntroduction>
      <Heading>Odkryj Pieluszki, które troszczą się tak, jak Ty!</Heading>
      <WelcomeContent>
        Twoje dziecko zasługuje na wszystko co najlepsze - także wtedy, gdy
        mówimy o codziennej pielęgnacji i komforcie. Nasze jednorazowe pieluszki
        BAMBI to nie tylko praktyczne rozwiązanie, ale przede wszystkim miękki
        dotyk bezpieczeństwa, który towarzyszy maluchowi od pierwszych dni
        życia.
      </WelcomeContent>
    </BoxIntroduction>
  </Introduction>
)

export default Intro
